import NavMenu from '../../components/navbar/NavMenu'
import SchoolBusNavMenu from '../../components/createForm/SchoolBusNavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import TrackAllVehicle from '../../components/vehicle/TrackAllVehicle'
import { useLocation } from 'react-router-dom'


export default function TrackVehiclesPage() {
    const location = useLocation()
    const isSchoolApp = new URLSearchParams(location.search).get('app') === 'school'
    const NavigationMenu = isSchoolApp ? SchoolBusNavMenu : NavMenu

    return (
        <>
            <TitleBar />
            <NavigationMenu />
            <TrackAllVehicle isSchoolApp={isSchoolApp} />
        </>
    )
}